
// breakpoint settings
export const MOBILE_NAV_BREAKPOINT = 800;
export const TEXT_FIELD_COUNT_MINIMUM = 4; // to avoid unnecessary searches



// WEBPACK FOOTER //
// ./src/config/options.js